<script setup lang="ts">
import type { KjdsDetailPageProps } from '@/types/appTypes'

const props = withDefaults(defineProps<KjdsDetailPageProps>(), {})

const route = useRoute()
const router = useRouter()
const app = useNuxtApp()
const storeIndex = useStoreIndex()
const storeUser = useStoreUser()

if (import.meta.client) {
  if (!storeUser.state.isLogin) {
    storeUser.setLoginRedirectPath(route.fullPath)
    router.replace('/login')
  }
}

const baseTitle = '学芸員の求人・募集'
let headTitle = ''
let headDescription = ''
const refData = reactive({ lastQuery: storeIndex.state.gakugeiinLastQuery })

const setHead = () => {
  const articleTitle = props.kjdsDetailData.article.title
  headTitle = `${articleTitle} | ${baseTitle}`
  headDescription = `${props.kjdsDetailData.article.title}の情報ページ。美術館や博物館などミュージアムで働きたい方は必見です。学芸員の求人・求職ならアイエム［インターネットミュージアム］で！`
  if (props.kjdsDetailData.article.description?.length) {
    headDescription = props.kjdsDetailData.article.description
  }
  // ぱんくず作成
  storeIndex.setBreadCrumbs([
    {
      text: baseTitle,
      disabled: false,
      to: { path: '/gakugeiin/' },
    },
    {
      text: articleTitle,
      disabled: true,
    },
  ])

  const headInput = app.$makeMeta({
    title: headTitle,
    description: headDescription,
  })
  useHead(headInput)
}

setHead()
</script>

<template>
  <div
    v-if="storeUser.state.isLogin"
    class="p-articlePage"
  >
    <GakugeiinBody
      v-bind:item="kjdsDetailData.article"
      v-bind:objects="kjdsDetailData.objects"
    />
    <div class="c-related">
      <nuxt-link
        class="c-related_link_btn"
        v-bind:to="{ path: '/gakugeiin', query: refData.lastQuery }"
      >
        募集⼀覧に戻る
      </nuxt-link>
    </div>
    <div class="p-articlePage_search">
      <GakugeiinSearchPanel
        v-bind:query="refData.lastQuery"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.p-articlePage {
  &_search {
    margin-top: 80px;
  }
}

.c-related {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  color: var(--color_primary_link);
  font-size: 14px;

  @include responsive.mq_down(sp) {
    margin-bottom: 50px;
  }
}
</style>
